import React from "react";
import Logo from "../assets/logo.svg";
import { delay, motion } from "framer-motion";

const Contact = () => {
  // إعدادات الحركات
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        delayChildren: 0.2,
        staggerChildren: 0.15,
      },
    },
  };

  const formVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.15,
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: 0.4,
        ease: "circOut"
      }
    },
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: 0.4,
        delay: 0.4,
        ease: "circOut"
      }
    },
    hover: { 
      scale: 1.05,
      transition: { 
        duration: 0.2,
        ease: "easeInOut"
      }
    },
    tap: { 
      scale: 0.95,
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
      transition: { 
        duration: 0.1,
        ease: "easeInOut"
      }
    }
  };

  const inputsContainerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { 
        duration: 0.4,
        ease: "circOut"
      },
    },
  };

  const textareaVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { 
        duration: 0.4,
        ease: "circOut"
      }
    },
  };

  return (
    <section id="contact" className="container m-auto px-4 md:px-0">
      <motion.div
        className="h-screen w-full md:w-[80%] m-auto bg-background flex flex-col justify-center items-center gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
      >
        {/* العنوان */}
        <motion.div className="flex flex-col gap-4 items-center md:mt-20" variants={childVariants}>
          <div className="flex flex-col gap-2 items-center">
            <img src={Logo} alt="Logo" width={"24px"} />
            <h2 className="text-2xl md:text-4xl font-semibold">Let’s Work Together</h2>
          </div>
          <p className="text-md md:text-xl text-center">
            Get in touch with me. I'm excited to learn about your project.
          </p>
        </motion.div>

        {/* النموذج */}
        <motion.form
          className="flex flex-col w-full gap-6"
          variants={formVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div 
            className="flex flex-col md:flex-row gap-6"
            variants={inputsContainerVariants}
          >
            <motion.input
              type="text"
              className="bg-white bg-opacity-10 text-gray-300 py-4 px-4 rounded-md flex-auto focus:outline-none focus:outline-1 focus:outline-gray-900"
              placeholder="Enter your name"
              variants={childVariants}
            />
            <motion.input
              type="text"
              className="bg-white bg-opacity-10 text-gray-300 py-4 px-4 rounded-md flex-auto focus:outline-none focus:outline-1 focus:outline-gray-900"
              placeholder="Enter your email address"
              variants={childVariants}
            />
          </motion.div>
          <motion.textarea
            className="bg-white bg-opacity-10 text-gray-300 py-4 px-4 rounded-md flex-auto h-60 focus:outline-none focus:outline-1 focus:outline-gray-900"
            placeholder="Enter your message"
            variants={textareaVariants}
          />
          <motion.button
            className="py-4 px-8 bg-primary_800 hover:bg-primary_700 transition-all delay-100 rounded-lg text-2xl font-semibold w-full md:w-[30%] m-auto shadow-lg"
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
          >
            Send Message
          </motion.button>
        </motion.form>
      </motion.div>
    </section>
  );
};

export default Contact;
